import React, {useEffect, useState} from "react";
import reports_api from "../api/protected/reports"
import tick from "../assets/co-coaches-tick.svg";
import cross from "../assets/co-coaches-cross.svg";
import search from "../assets/search.png";
import download from "../assets/download-pdf-temp.png"
import del from "../assets/delete-bin.svg"
import info from "../assets/info-icon.png";
import TitleDescriptionPopup from "../components/TitleDescriptionPopup";
import VerifyEmailPopup from "../components/VerifyEmailPopup";
import dashboard_api from "../api/protected/dashboard";

const Reports = () => {

    const [reports, setReports] = useState([])
    const [showDeleteDialogue, setShowDeleteDialogue] = useState(false)
    const [activeID, setActiveID] = useState(0)

    const [showTitleHover, setShowTitleHover] = useState(false)
    const titleDescription = ["Any report that you have configured and generated from the survey summary will " +
    "be saved and listed here. Select from the list below to view or delete a report. You can edit an existing report or " +
    "generate a new report from the Surveys page."]
    const titlePopupStyle = {top: 35, left: 155}

    const GetReports = () => {
        let response = reports_api.getReports()
        response.then(response => {
            setReports(response.data)
        }).catch(err => console.log(err))
    }

    useEffect(() => {
        GetReports()
    }, []);

    const [showVerifyEmailPopup, setShowVerifyEmailPopup] = useState(false);
    useEffect(() => {
        dashboard_api.getValidateEmail().then((response) => {
            const isAlreadyVerified = response.data === 1;

            if (!isAlreadyVerified) {
                setShowVerifyEmailPopup(true)
                console.log("You are not verified. Please click the link in your email.")
            } else {
                setShowVerifyEmailPopup(false)
                console.log("You are verified. Please carry on.")
            }
        })
    }, []);

    const formatDate = (timestamp) => {
        if(!timestamp) return;
        let current_date = new Date(timestamp * 1000);
        return `${current_date.getDate()}/${current_date.getMonth() + 1}/${current_date.getFullYear()}`
    }

    const DownloadReport = (ev, report_id, filename) => {
        if(!ev) return;
        let response = reports_api.downloadReport(report_id);
        response.then(response => {
            let a = document.createElement("a");
            a.href = response.data;
            a.download = `${filename}.pdf`;
            a.click();
        }).catch(err => console.log(err))
    }

    const DeleteReport = (ev) => {
        if(!ev) return;
        setShowDeleteDialogue(false)
        let response = reports_api.deleteReport(activeID);
        response.then(response => {
            setActiveID(0)
            GetReports()
        }).catch(err => console.log(err))
    }

    const ShowDeleteDialogue = (ev, report_id) => {
        if(!ev) return;
        setActiveID(report_id)
        setShowDeleteDialogue(true)
    }

    const CloseDeleteDialogue = (ev) => {
        if(!ev) return;
        setActiveID(0)
        setShowDeleteDialogue(false)
    }

    return (
        <>
            <div className="reports-page-background-container">
                <div className="reports-page-container">
                    <div className="reports-page-header">
                        <div className="page-header-title-container">
                            <div className="reports-page-title">Reports</div>
                            <img src={info} alt="Info"
                                 onMouseOver={() => setShowTitleHover(true)}
                                 onMouseLeave={() => setShowTitleHover(false)}
                            />
                            {showTitleHover ?
                                <TitleDescriptionPopup text={titleDescription} style={titlePopupStyle}/>
                                :null}
                        </div>
                        <div className="reports-page-search-container">
                            <input type="text" placeholder="Report Search"/>
                            <img src={search} alt="search icon" className="link"/>
                        </div>
                    </div>
                    <div className="reports-page-report-headers medium">
                        <div className="report-organisation">Organisation</div>
                        <div className="report-organisation">Team</div>
                        <div className="report-type">Report Type</div>
                        <div className="report-organisation">Report Name</div>
                        <div className="report-survey-type">Survey Type</div>
                        <div className="report-point">Survey Point</div>
                        <div className="report-date">Survey Date</div>
                        <div className="report-date">Report Date</div>
                        <div className="report-controls"/>
                    </div>
                    {reports.map((report, idx) => {
                        return (
                            <div className="reports-page-report-row regular" key={idx}>
                                <div className="report-organisation">{report.organisation_name || "N/A"}</div>
                                <div className="report-organisation">{report.team_name || "N/A"}</div>
                                <div className="report-type">{report.type.toUpperCase()}</div>
                                <div className="report-organisation">{report.name || "N/A"}</div>
                                <div className="report-survey-type">{report.survey_type || "N/A"}</div>
                                <div className="report-point">{report.survey_point || "N/A"}</div>
                                <div className="report-date">{formatDate(report.survey_date) || "N/A"}</div>
                                <div className="report-date">{formatDate(report.timestamp)}</div>
                                <div className="report-controls">
                                    <div className="reports-row-button download" onClick={ev => DownloadReport(ev, report.id, report.name ? report.name : "report")}>
                                        <img src={download} alt="Download PDF"/>
                                    </div>
                                    <div className="reports-row-button" onClick={ev => ShowDeleteDialogue(ev, report.id)}>
                                        <img src={del} alt="Delete Report"/>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            {showDeleteDialogue ?
                <>
                    <div className="page-mask" onClick={CloseDeleteDialogue}/>
                    <div className="reports-delete-popup">
                        <div className="co-coachs-delete-popup-title bold">Are you sure you want to delete this report?</div>
                        <div className="co-coaches-delete-popup-controls-container">
                            <div className="co-coaches-delete-popup-button">
                                <img src={tick} alt="Yes" onClick={DeleteReport}/>
                            </div>
                            <div className="co-coaches-delete-popup-button">
                                <img src={cross} alt="No" onClick={CloseDeleteDialogue}/>
                            </div>
                        </div>
                    </div>
                </> : null
            }
            {showVerifyEmailPopup && showVerifyEmailPopup ?
                <VerifyEmailPopup wide={false} /> : null }
        </>
    )
}

export default Reports
